import capitalize from "lodash/capitalize";

import { EMPTY_CELL_HYPHEN } from "../constants";

export const formatCommodities = (commodities: string | undefined, fallback = EMPTY_CELL_HYPHEN): string => {
  return commodities ? commodities.split(",").map(capitalize).join(", ") : fallback;
};
